import localforage from 'localforage'
import Api from '../core/Api'
import Offline from './Offline'

class PhotoFiche {

    static serialize(data){

        let payload = {};

        payload.id = data.id;
        payload.idFibsdd = data.idFi;
        payload.photo64 = data.data64;

        return payload

    }

    static async addOnline(id) {

        let api = await Api.init();

        let photo = await PhotoFiche.getPhotoFiche(id);
        let payload = PhotoFiche.serialize(photo);
        let idFiche = payload.idFibsdd;

        delete payload.idFibsdd;
        delete payload.id;

        try {
            await api.post('/photo/' + idFiche, payload);
            await Offline.deleteAction(id, 'PhotoFiche');
            return true;
        } catch (err) {}

    }

    static async removeOnline(id){

        let api = await Api.init();

        api
            .delete('/photo/' + id)
            .then(() => {

                Offline.deleteAction(id, 'PhotoFiche').then(() => {
                    resolve(true)
                })

            })
            .then(() => true)
            .catch()

    }

    static async addOffline(data) {

        try {

            let photos = await PhotoFiche.getList();
            photos.push(data);
            await localforage.setItem('listPhotos', JSON.stringify(photos));
            await Offline.saveAction({action: 'add', type: 'PhotoFiche', id: data.id});
            return true

        } catch (e) {

            return false

        }

    }

    static async remove(id) {
        let photos = await PhotoFiche.getList();

        try {

            let newList = _.remove(photos, p => p.id !== id);
            await localforage.setItem('listPhotos', JSON.stringify(newList));

            if(!_.includes(id, 'P-')){

                Offline.saveAction({
                    type: "PhotoFiche",
                    action: "delete",
                    id: id
                })
            } else {
                Offline.deleteAction(id, 'PhotoFiche')
            }

        } catch (err) {
            return false
        }

        return true
    }

    static async getListForFiche(idFiche) {

        let photos = await PhotoFiche.getList();
        return photos.filter( p => String(p.idFi) === String(idFiche) )

    }

    static async getPhotoFiche( id ) {

        let list = await PhotoFiche.getList();
        return list.find( p => p.id === id )

    }

    static async getList() {

        return JSON.parse( await localforage.getItem('listPhotos'))

    }

}

export default PhotoFiche



// WEBPACK FOOTER //
// ./src/js/models/PhotoFiche.js